import { useUserPreference } from "../../../hooks/useProfilePreferencesQuery";
import InfoBox from "@coworker/components/src/components/InfoBox";

export default function TaskFormInstructions({ conf }) {
  const [userPreferenceInstructions, setUserPreferenceInstructions] =
    useUserPreference(conf.type, false);

  if (userPreferenceInstructions) {
    return null;
  }

  return (
    <InfoBox
      {...conf}
      onClose={() => {
        setUserPreferenceInstructions(true);
      }}
    />
  );
}
